module.exports = __webpack_public_path__ + "static/img/album1.89dea95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybenefits/album1.png
// module id = OFUm
// module chunks = 1